import useParseLinkUrlWithLocale from '@/lib/hooks/routing/useParseLinkUrlWithLocale'
import { cn } from '@/lib/utils'
import Image from 'next/image'

import { AlertBanner } from '@/components/AlertBanner'
import { SystemStatusBanner } from '@/components/SystemStatusBanner'
import { useGetTopMarqueeBanner } from '@/lib/hooks/services/useGetTopMarqueeBanner'
import { useFocusMode } from '@/lib/hooks/helpers/useFocusMode'
import useGlobalStore from '@/store/useGlobalStore'
import { AccountPageHeader } from '../AccountPageHeader'
import DesktopHeader from '../DesktopHeader'
import MobileHeader from '../MobileHeader'

type Props = {
  simple?: boolean
  account?: boolean
}

const Header = ({ simple, account }: Props) => {
  const {
    app: { alpha2 },
  } = useGlobalStore()
  const { parseLinkUrlWithLocale } = useParseLinkUrlWithLocale()

  const {
    isLoading: isTopMarqueeBannerLoading,
    topMarqueeText,
    topMarqueeBackgroundColor,
  } = useGetTopMarqueeBanner()

  const { isFocusMode, isLoadingIsFocusMode } = useFocusMode()

  if (simple) {
    return (
      <>
        <SystemStatusBanner />

        <div className="flex h-[60px] items-center justify-between bg-white p-5">
          <a
            href={
              !isFocusMode ? parseLinkUrlWithLocale({ url: '/' }) : undefined
            }
          >
            <Image src="/unicity.svg" alt="Unicity" width={120} height={100} />
          </a>
          <Image
            src={`/flags/${alpha2}.svg`}
            alt="flag"
            width={28}
            height={28}
          />
        </div>
      </>
    )
  }

  if (account)
    return (
      <>
        <SystemStatusBanner />

        <div className="relative">
          <AccountPageHeader />
        </div>
      </>
    )

  return (
    <>
      <SystemStatusBanner />

      {/* Don't show if focus mode check is loading, if in focus mode, if marquee is loading or if no text */}
      {!isFocusMode &&
        !isLoadingIsFocusMode &&
        !isTopMarqueeBannerLoading &&
        topMarqueeText && (
          <AlertBanner
            text={topMarqueeText}
            backgroundColor={topMarqueeBackgroundColor}
            isMarquee
          />
        )}

      <div className="block max-h-screen lg:hidden">
        <MobileHeader />
      </div>

      <div className={cn(`relative hidden max-h-screen lg:block`)}>
        <DesktopHeader />
      </div>
    </>
  )
}

export default Header
